import React, {FunctionComponent, useCallback, useEffect, useState} from 'react';
import {CaptchaV2} from "./captchaV2.component";
import {useHumanValidation} from "./captchaV3Hook";

const styles = require<any>('./captcha.component.scss');

interface CaptchaProps {
    onRunCaptchaChanged: (runCaptcha: ReturnType<typeof useHumanValidation>) => void;
    onSuccess: () => void;
    actionName: string;
    disableSubmit: (value: boolean) => void;
    showError: (value: boolean) => void;
    className?: string;
}

export const Captcha: FunctionComponent<CaptchaProps> = props => {
    const {className, onRunCaptchaChanged, onSuccess, actionName, disableSubmit, showError} = props;
    const [v2Token, setV2Token] = useState('');
    const [showV2, setShowV2] = useState(false);
    
    const onV3Fail = useCallback( () => {
        setShowV2(true);
    },[]);

    const verifyCallback = useCallback((response: string) => {
        setV2Token(response);
        disableSubmit(false);
        showError(false);
    }, [disableSubmit, showError]);

    const setExpired = useCallback(() => {
        disableSubmit(true);
    },[disableSubmit]);
    
    const runCaptcha = useHumanValidation(onSuccess, actionName, onV3Fail, v2Token, disableSubmit, showError);

    useEffect(() => {
        onRunCaptchaChanged(runCaptcha);
    }, [onRunCaptchaChanged, runCaptcha]);
    if (showV2) {
        return <CaptchaV2 onVerify={verifyCallback} onExpire={setExpired} className={`${styles.recaptcha} ${className || ''}`}/>;
    } else {
        return null;
    }
};